// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"Dashboard_dashboardWrapper__D9hM3","greetings":"Dashboard_greetings__2C8eg","locationOverviewWrapper":"Dashboard_locationOverviewWrapper__1MPWo"};